import {
    MAKE_SALE_REQUEST,
    PROMISE_PENDING,
		PROMISE_REJECTED,
    PROMISE_FULFILLED,
    SELLER_UPLOAD_PHOTO,
    SAVING_SELLER_IMAGE,
    SUSPEND_SELL_REQUEST,
    UPDATE_LISTING_EXPIRY,
    FETCH_PRICE_COMPETITOR,
    GET_TRANSACTION_TIMELINE
} from '../constants';

import onError from "../utils/error";

const defaultError={
    error:{
        message:'I got something undefined errors',
        status_code:500
    }
}

const initialState = {
    sellRequest: {
        details: null,
        message: '',
        status_code: 0,
        isFetch: false,
        error: null,
    },
    uploadPhotos: {
        detailsUrl: [],
        stepUpload: 0,
        message: '',
        status_code: 0,
        onProgress: false,
        error: null
    },
    loggingImage: {
        totalImage: 0,
        status_code: 0,
        message: ''
    },
    suspended: {
      isFetch: false,
      error: null
    },
    listingExpiry: {
      data: null,
      isSubmit: false,
      error: null,
      status_code: 0
    },
    priceCompetitor: {
      isFetch: false,
      data: {
        highest_price: 1000000000,
        lowest_price: 50000,
        max_price: 0,
        min_price: 0,
        seller_commission: 0,
        seller_price: 0
      },
      error: null
    },
    timeline: {
      isFetch: false,
      message: '',
      status_code : 0,
      data: [],
      error: null
    },
    selectedUserSell: null
}

const sellingReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${MAKE_SALE_REQUEST}${PROMISE_PENDING}`:
            return {...state, sellRequest: {...state.sellRequest, isFetch: true, status_code: 0 }}
        case `${MAKE_SALE_REQUEST}${PROMISE_FULFILLED}`: {
            const { data, status_code, message } = action.payload;
            return {...state, sellRequest: {...state.sellRequest, details: data, status_code, message, isFetch: false}}
        }
        case `${MAKE_SALE_REQUEST}${PROMISE_REJECTED}`: {
            return {...state, sellRequest: {...state.sellRequest, isFetch: false, ...onError(action.payload)}}
        }
        case `${GET_TRANSACTION_TIMELINE}${PROMISE_PENDING}`:
            return {...state, timeline: {...state.timeline, isFetch: true, status_code: 0 }}
        case `${GET_TRANSACTION_TIMELINE}${PROMISE_FULFILLED}`: {
            const { data, status_code, message } = action.payload;
            return {...state, timeline: {...state.timeline, data: data.data[0].value, status_code, message, isFetch: false}}
        }
        case `${GET_TRANSACTION_TIMELINE}${PROMISE_REJECTED}`: {
            return {...state, timeline: {...state.timeline, isFetch: false, ...onError(action.payload)}}
        }

        case `${GET_TRANSACTION_TIMELINE}${PROMISE_PENDING}`:
	             return {...state, timeline: {...state.timeline, isFetch: true, status_code: 0 }}
        case `${GET_TRANSACTION_TIMELINE}${PROMISE_FULFILLED}`: {
            const { data, status_code, message } = action.payload;
            return {...state, timeline: {...state.timeline, data: data.data[0].value, status_code, message, isFetch: false}}
        }
        case `${GET_TRANSACTION_TIMELINE}${PROMISE_REJECTED}`: {
            return {...state, timeline: {...state.timeline, isFetch: false, ...onError(action.payload)}}
        }

        case SELLER_UPLOAD_PHOTO: {
            const { url, stepUpload } = action.payload;
            return {
                ...state,
                uploadPhotos:{...state.uploadPhotos,
                    message: 'Success',
                    status_code: 200,
                    stepUpload,
                    onProgress: action.isProgress,
                    detailsUrl: [...state.uploadPhotos.detailsUrl, url]
                },
                loggingImage: {...initialState.loggingImage}
            }
        }
        case `${SAVING_SELLER_IMAGE}${PROMISE_PENDING}`:
            return {...state,
                loggingImage: { ...state.loggingImage, totalImage: 0, message: '', status_code: 0 }
            }
        case `${SAVING_SELLER_IMAGE}${PROMISE_FULFILLED}`: {
            const { status_code, data, message } = action.payload;
            return {...state,
                loggingImage: {...state.loggingImage, status_code, totalImage: data && data.user_sell_images.length, message },
                uploadPhotos: {...initialState.uploadPhotos},
                sellRequest: {...initialState.sellRequest}
            }
        }
        case `${SUSPEND_SELL_REQUEST}${PROMISE_PENDING}`: return(
          {
            ...state, 
            "suspended": {
              ...state.suspended, 
              isFetch: true
            }
        })
        case `${SUSPEND_SELL_REQUEST}${PROMISE_FULFILLED}`: {
          return { ...state, 
            "suspended": {
              ...state.suspended, 
              isFetch: false, 
              error: null, 
              message: action.payload.message, 
              status_code: action.payload.status_code
            }
          }
        } 
        case `${SUSPEND_SELL_REQUEST}${PROMISE_REJECTED}`: {
          return { ...state, 
           "suspended": {
              ...state.suspended, 
              isFetch: false, 
              error: {
                message: action?.payload?.response?.data?.error?.message?? action.payload.message
              }, 
            }
          }
        }

        //update listing expiry
        case `${UPDATE_LISTING_EXPIRY}${PROMISE_PENDING}`: 
          return { ...state, listingExpiry: { ...state.listingExpiry, isSubmit: true }}
        case `${UPDATE_LISTING_EXPIRY}${PROMISE_FULFILLED}`: {
          const { data, status_code, message } = action.payload;
          return { ...state, listingExpiry: { ...state.listingExpiry, data, status_code, isSubmit: false, error: null }}
        }
        case `${UPDATE_LISTING_EXPIRY}${PROMISE_REJECTED}`:
          return { ...state, listingExpiry: { ...state.listingExpiry, ...onError(action.payload), isSubmit: false }}


    case `${FETCH_PRICE_COMPETITOR}${PROMISE_PENDING}`: {
      return { 
        ...state,
        priceCompetitor: { ...state.priceCompetitor, isFetch: true }
      }
    }
    case `${FETCH_PRICE_COMPETITOR}${PROMISE_FULFILLED}`: {
      const { data, status_code } = action.payload;

      return { 
        ...state,
        priceCompetitor: { 
          ...state.priceCompetitor, 
          isFetch: false, 
          data, 
          error: null 
        }
      }
    }
    case `${FETCH_PRICE_COMPETITOR}${PROMISE_REJECTED}`: 
      return { 
        ...state,
        priceCompetitor: { 
          ...state.priceCompetitor, 
          isFetch: false, 
          error: onError(action.payload) && onError(action.payload).error,
        }
      }
    case 'SET_SELECTED_USER_SELL': {
      return {
        ...state,
        selectedUserSell: action.payload
      }
    }
          
				default : return state
    }
}

export default sellingReducer;
